import { useEffect } from 'react';
import { useUserStore } from 'shared/state/user';
import useBreederStore from 'shared/state/breeder';
import { ReloadPage } from 'shared/components/reload-page';
import { Props } from 'shared/@types';
import { DefaultProps } from '@web/library/with-server-props';
import { useRouter } from 'shared/library/use-router';
import { useRoute } from 'shared/library/routes/route';

export function AuthGuard({ defaultProps, children }: Props<DefaultProps>) {
  const router = useRouter();
  const route = useRoute();
  const user = useUserStore((state) => state.user);
  const hasBreeder = useBreederStore((state) => !!state.breeder);
  // Breeder pages assume a breeder; without one, send the user to create it.
  const missingBreeder = defaultProps.requiresBreeder && !!user && !hasBreeder;

  useEffect(() => {
    if (missingBreeder) {
      void router.replace(route('me.breeder.index'));
    }
  }, [missingBreeder]);

  if (defaultProps.requiresAuth && !user) {
    return <ReloadPage />;
  }

  if (missingBreeder) {
    return null;
  }

  return <>{children}</>;
}
